import { isBelowiOS26 } from '@/lib/utils/iosCompat'
import SystemLayout from '@/views/layouts/SystemLayout'
import { useTheme } from 'expo-router/react-navigation'
import { Stack, type NativeStackNavigationOptions } from 'expo-router'
import { Platform } from 'react-native'

export default function SystemGroup() {
  const theme = useTheme()

  return (
    <SystemLayout>
      <Stack
        screenOptions={{
          title: '',
          headerLargeTitle: false,
          headerShadowVisible: false,
          headerBackButtonDisplayMode: 'minimal',
          contentStyle: {
            backgroundColor: theme.colors.background,
          },
          ...Platform.select<NativeStackNavigationOptions>({
            ios: {
              headerTransparent: true,
              ...(isBelowiOS26 ? { headerBlurEffect: 'systemChromeMaterial' as const } : {}),
            },
            android: {
              headerTransparent: false,
              headerStyle: { backgroundColor: theme.colors.background },
            },
          }),
        }}
      >
        {/* main tabs screen */}
        <Stack.Screen name="(tabs)" options={{ headerShown: false }} />

        <Stack.Screen name="jiri/index" options={{ title: 'Jiri', headerTransparent: false }} />

        {/* covers screens */}
        <Stack.Screen name="(covers)/participated_forms" options={{ title: '填表记录' }} />
        <Stack.Screen name="(covers)/form_trash" options={{ title: '回收站' }} />
        <Stack.Screen name="participated_forms/[token]/entries" options={{ title: '记录详情' }} />

        {/* forms screens */}
        <Stack.Screen name="forms/ai_create/index" options={{ title: 'AI 创建表单' }} />
        <Stack.Screen name="forms/ai_create/preview" options={{ title: '预览表单', headerTransparent: false }} />
        <Stack.Screen name="forms/[formToken]/setting/cooperators" options={{ title: '团队协作' }} />
        <Stack.Screen name="forms/[formToken]/setting/invite_cooperators" options={{ title: '邀请成员' }} />

        {/* templates screens */}
        <Stack.Screen name="templates/index" options={{ title: '模板中心' }} />
        <Stack.Screen name="templates/[templateToken]/index" options={{ title: '模板详情' }} />

        {/* profile screens */}
        <Stack.Screen name="profile/userInfo" options={{ title: '个人信息' }} />
        <Stack.Screen name="profile/planQuota" options={{ title: '套餐余量' }} />
        <Stack.Screen name="profile/plans" options={{ title: '升级套餐' }} />
        <Stack.Screen name="profile/iosPaywall" options={{ title: '升级套餐' }} />
        <Stack.Screen name="profile/switchUser" options={{ title: '切换团队' }} />
        <Stack.Screen name="profile/users" options={{ title: '团队成员' }} />
        <Stack.Screen name="profile/users/[id]" options={{ title: '成员详情' }} />
        <Stack.Screen name="profile/invite_user" options={{ title: '邀请成员' }} />
        <Stack.Screen name="profile/customerService" options={{ title: '在线客服' }} />
        <Stack.Screen name="profile/terms" options={{ title: '使用条款' }} />
        <Stack.Screen name="profile/privacy" options={{ title: '隐私政策' }} />
        <Stack.Screen name="profile/permissions" options={{ title: 'App 权限' }} />
        <Stack.Screen name="profile/diagnostics" options={{ title: '诊断信息' }} />
        <Stack.Screen name="profile/pay_result" options={{ title: '支付结果' }} />
      </Stack>
    </SystemLayout>
  )
}
